import styled from 'styled-components';
import { boxStyles } from '../Box/styles.js';
var GapWrapper =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "styles__GapWrapper",
  componentId: "eltaad-0"
})(["", ""], boxStyles);
var GapContainer =
/*#__PURE__*/
styled.span.withConfig({
  displayName: "styles__GapContainer",
  componentId: "eltaad-1"
})(["", ""], boxStyles);
export { GapContainer, GapWrapper };